module.exports = __webpack_public_path__ + "img/A58A0134_min.f289cf4e.jpg";